var React = require('react');

function CheckmarkDisable (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"24","height":"24","x":"2","y":"2","stroke":"#9DA9B6","strokeWidth":"1.538","rx":"12","key":0}),React.createElement("g",{"fill":"#9DA9B6","fillRule":"nonzero","transform":"translate(6.615 9.077)","key":1},[React.createElement("rect",{"width":"7.229","height":"1.846","x":"-.308","y":"6.599","rx":".923","transform":"rotate(45 3.307 7.522)","key":0}),React.createElement("rect",{"width":"13.231","height":"1.846","x":"2.621","y":"4.478","rx":".923","transform":"rotate(135 9.236 5.4)","key":1})])]));
}

CheckmarkDisable.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = CheckmarkDisable;

CheckmarkDisable.default = CheckmarkDisable;
